import { 
    INE_DASHBOARD_START_LOADING, 
    INE_DASHBOARD_END_LOADING, 
    SET_INE_DASHBOARD_FILTER_SEARCH,
    SET_INE_DASHBOARD_FILTER_MINE_ONLY,
    INE_DASHBOARD_DRAFT_LOADED, 
    INE_DASHBOARD_NEW_LOADED,
    INE_DASHBOARD_PENDING_APPROVAL_LOADED,
    INE_DASHBOARD_REJECTED_LOADED,
    INE_DASHBOARD_SALES_ACTION_LOADED,
    INE_DASHBOARD_APPROVAL_OF_CONTRACT_LOADED,
    INE_DASHBOARD_ISSUE_WORK_ORDER_FORM_LOADED,
    INE_DASHBOARD_PERFORM_INSPECTION_LOADED,
    INE_DASHBOARD_AWAITING_SIGNATURE_LOADED,
    INE_DASHBOARD_COMPLETED_LOADED,
    INE_DASHBOARD_CLOSED_LOADED,
    INE_DASHBOARD_ABORTED_LOADED,
    INE_DASHBOARD_AREA_MANAGER_USER_LOADED,
    INE_DASHBOARD_TECHNICAL_MANAGER_USER_LOADED,
    INE_DASHBOARD_INSPECTOR_USER_LOADED,
    INE_DASHBOARD_FINANCE_USER_LOADED,
    INE_DASHBOARD_USER_SEARCH_LOADED
} from "../constants/IneDashboardConstants";

const initialState = {
    loading: false,
    search: "",
    mineOnly: true,
    draftList: [],
    newList: [],
    pendingApprovalList: [],
    rejectedList: [],
    salesActionList: [],
    approvalOfContractList: [],
    issueWorkOrderFormList: [],
    performInspectionList: [],
    awaitingSignatureList: [],
    completedList: [],
    closedList: [],
    abortedList: [],
    areaManagerUserList: [],
    technicalManagerUserList: [],
    inspectorUserList: [],
    financeUserList: [],
    searchList: []
};

const IneDashboardReducer = (state = initialState, action) => {
    switch(action.type) {
        case INE_DASHBOARD_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case INE_DASHBOARD_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case SET_INE_DASHBOARD_FILTER_SEARCH:
            return {
                ...state,
                search: action.payload
            };
        case SET_INE_DASHBOARD_FILTER_MINE_ONLY:
            return {
                ...state,
                mineOnly: action.payload
            };
        case INE_DASHBOARD_DRAFT_LOADED:
            return {
                ...state,
                draftList: action.payload
            };
        case INE_DASHBOARD_NEW_LOADED:
            return {
                ...state,
                newList: action.payload
            };
        case INE_DASHBOARD_PENDING_APPROVAL_LOADED:
            return {
                ...state,
                pendingApprovalList: action.payload
            };
        case INE_DASHBOARD_REJECTED_LOADED:
            return {
                ...state,
                rejectedList: action.payload
            };
        case INE_DASHBOARD_SALES_ACTION_LOADED:
            return {
                ...state,
                salesActionList: action.payload
            };
        case INE_DASHBOARD_APPROVAL_OF_CONTRACT_LOADED:
            return {
                ...state,
                approvalOfContractList: action.payload
            };
        case INE_DASHBOARD_ISSUE_WORK_ORDER_FORM_LOADED:
            return {
                ...state,
                issueWorkOrderFormList: action.payload
            };
        case INE_DASHBOARD_PERFORM_INSPECTION_LOADED:
            return {
                ...state,
                performInspectionList: action.payload
            };
        case INE_DASHBOARD_AWAITING_SIGNATURE_LOADED:
            return {
                ...state,
                awaitingSignatureList: action.payload
            };
        case INE_DASHBOARD_COMPLETED_LOADED:
            return {
                ...state,
                completedList: action.payload
            };
        case INE_DASHBOARD_CLOSED_LOADED:
            return {
                ...state,
                closedList: action.payload
            };
        case INE_DASHBOARD_ABORTED_LOADED:
            return {
                ...state,
                abortedList: action.payload
            };
        case INE_DASHBOARD_AREA_MANAGER_USER_LOADED:
            return {
                ...state,
                areaManagerUserList: action.payload
            };
        case INE_DASHBOARD_TECHNICAL_MANAGER_USER_LOADED:
            return {
                ...state,
                technicalManagerUserList: action.payload
            };
        case INE_DASHBOARD_INSPECTOR_USER_LOADED:
            return {
                ...state,
                inspectorUserList: action.payload
            };
        case INE_DASHBOARD_FINANCE_USER_LOADED:
            return {
                ...state,
                financeUserList: action.payload
            };
        case INE_DASHBOARD_USER_SEARCH_LOADED:
            return {
                ...state,
                searchList: action.payload
            };
        default:
            return state;
    }
}

export default IneDashboardReducer;
